module.exports = __webpack_public_path__ + "static/media/icons-ellipsis-v.1af684b1.svg";